import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { waLink } from "@/lib/site";

const PRODUCTS = [
  {
    title: "Persianas Sher elegance",
    desc: "Elegancia y control de luz en una sola persiana. Ideal para espacios modernos y sofisticados.",
    img: "/images/sherelegance.png",
  },
  {
    title: "Persianas enrollable screen",
    desc: "Diseño minimalista y funcional para regular la entrada de luz con estilo y practicidad.",
    img: "/images/enrollable.png",
  },
  {
    title: "Black out",
    desc: "Bloqueo total de luz y máxima privacidad. Perfectas para recámaras y salas de TV.",
    img: "/images/black.png",
  },
  {
    title: "Lambrin",
    desc: "Acabado moderno para muros interiores que aporta textura, diseño y personalidad.",
    img: "/images/lambrim.jpeg",
  },
  {
    title: "Cortina Tradicional",
    desc: "Confeccionadas a medida para brindar calidez, elegancia y confort a cualquier ambiente.",
    img: "/images/tradicional.png",
  },
];

export default function Products() {
  return (
    <section
      id="productos"
      data-testid="products-section"
      className="section bg-persia-light"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14 md:mb-20">
          <div className="max-w-2xl">
            <div className="eyebrow mb-5">Colección</div>

            <h2 className="font-display font-semibold text-persia-black text-3xl md:text-5xl leading-[1.1]">
              Nuestros{" "}
              <span className="italic font-light text-gold">
                Productos
              </span>
            </h2>

            <p className="mt-5 text-persia text-base md:text-lg font-light">
              Persianas, cortinas y soluciones decorativas fabricadas e
              instaladas a la medida de cada espacio.
            </p>
          </div>

          <a
            href={waLink(
              "Hola, quiero conocer su catálogo completo de productos."
            )}
            target="_blank"
            rel="noreferrer"
            className="hidden md:inline-flex btn-gold"
          >
            Ver Catálogo Completo
            <ChevronRight size={16} />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-5">
          {PRODUCTS.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.6,
                delay: i * 0.08,
              }}
              className="group bg-white luxury-card overflow-hidden flex flex-col"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />

                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur px-3 py-1 font-display text-[10px] tracking-[0.22em] uppercase text-persia-black">
                  {String(i + 1).padStart(2, "0")}
                </div>
              </div>

              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-display text-persia-black font-semibold text-lg leading-tight">
                  {p.title}
                </h3>

                <p className="mt-3 text-persia text-sm font-light leading-relaxed flex-1">
                  {p.desc}
                </p>

                <a
                  href={waLink(
                    `Hola, me interesa cotizar ${p.title}.`
                  )}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-5 inline-flex items-center gap-2 font-display text-[11px] tracking-[0.22em] uppercase text-persia-black hover:text-gold transition-colors"
                >
                  Solicitar Cotización
                  <ChevronRight size={14} />
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}